jQuery.fn.within = function(pSelector) {
    return this.filter(function(){
        return jQuery(this).closest( pSelector ).length;
    });
};

document.addEventListener( 'DOMContentLoaded', function () {
	var elms = document.getElementsByClassName( 'splide' );
	for ( var i = 0, len = elms.length; i < len; i++ ) {
		var isThumbnailsGallery = (elms[ i ].classList.contains("ssnail-post-gallery-thumbnails"));
		if (isThumbnailsGallery) {
			continue;
		}
		var splideOptions = {
			type   : 'loop',
			perPage: 1,
			perMove: 1,
			autoplay: true,
			gap    : '1rem',
			lazyLoad: 'sequential',
            intersection: {
                inView: {
                    autoplay: true,
                },
                outView: {
                    autoplay: false,
                },
            },
		};
		var hasThumbnails = false;
		var isPostGallery = (elms[ i ].classList.contains("ssnail-post-gallery"));
		if (isPostGallery) {
			splideOptions.perPage = 1;
			var thumbnailsId = elms[i].dataset.thumbnailsId;
			if (thumbnailsId !== undefined) {
				hasThumbnails = true;
				var secondarySlider = new Splide( '#' + thumbnailsId, {
					rewind          : true,
					fixedWidth      : 96,
					fixedHeight     : 96,
					isNavigation    : true,
					gap             : 10,
					padding			: '5px',
					focus           : 'center',
					pagination      : false,
					cover           : true,
					lazyLoad: 'sequential',
					dragMinThreshold: {
						mouse: 4,
						touch: 10,
					},
					breakpoints : {
						640: {
							fixedWidth  : 64,
							fixedHeight : 64,
						},
					},
                    intersection: {
                        inView: {
                            autoplay: true,
                        },
                        outView: {
                            autoplay: false,
                        },
                    },
				} );
				splideOptions.arrows = false;
			}
		}
		var currentSplide = new Splide( elms[ i ], splideOptions );
		if (hasThumbnails) {
			currentSplide.sync(secondarySlider);
		}
		currentSplide.mount( window.splide.Extensions );
		if (hasThumbnails) {
			secondarySlider.mount( window.splide.Extensions );
		}
	}
} );

/*
document.addEventListener( 'DOMContentLoaded', function () {
	//GUTENBERG GALLERIES CANNOT BE HOOKED
	var existingGalleries = document.getElementsByClassName( 'wp-block-gallery' );
	for ( var i = 0, len = existingGalleries.length; i < len; i++ ) {
		var currentGallery = existingGalleries[ i ];
		var images = currentGallery.querySelectorAll('[class="blocks-gallery-item"]');
		var newGalleryHTML = '<div class="splide ssnail-post-gallery">'
				+'<div class="splide__track">'
				+	'<ul class="splide__list">';
		for ( var j = 0, len2 = images.length; j < len2; j++ ) {
			var currentImage = images[ j ];
			currentImage.classList.add('text-center');
			newGalleryHTML += '<div class="splide__slide">';
			newGalleryHTML += currentImage.outerHTML.replace("wp-image-", "img-fluid wp-image-");
			newGalleryHTML += '</div>';
		}
		newGalleryHTML += '</ul></div></div>';
		var newGallery = document.createElement('div');
		newGallery.classList.add('splide');
		newGallery.classList.add('ssnail-post-gallery');
		newGallery.innerHTML = newGalleryHTML;
		currentGallery.parentNode.insertBefore(newGallery, currentGallery);
		currentGallery.classList.add('ssnail-remove');
	}
	document.querySelectorAll('.ssnail-remove').forEach(e => e.remove());
	var elms = document.getElementsByClassName( 'splide' );
	for ( var i = 0, len = elms.length; i < len; i++ ) {
		var splideOptions = {
			type   : 'loop',
			perPage: 1,
			perMove: 1,
			autoplay: true,
			gap    : '1rem',
			lazyLoad: 'nearby',
			cover: true,
			width: '100vw',
			autoHeight: true,
			pagination: true
		};
		var currentSplide = new Splide( elms[ i ], splideOptions ).mount();
	}
} );
*/

( function( $ ) {
    var ssnailPage = $("html,body").first();

	$('[data-toggle="tooltip"]').tooltip();
    $(window).ready(function () {
        $(".ssnail-menu-wrapper.level-0 .menu-item").each(function(){
            var children = $(".ssnail-menu-wrapper.level-1 .menu-item[data-ssnail-menu-item-parent-id=" + $(this).data('ssnail-menu-item-id') + "]");
            if (children.length > 0) {
                $(this).addClass('has-children');
                $(this).find('.nav-link').append('<span class="ssnail-arrow float-right"><i class="fal fa-chevron-right"></i></span>');
                $(this).find('.ssnail-children-container').append(children.clone());
                var anchor = $(this).children("a");
                if (anchor !== undefined) {
                    anchor.addClass('prevent-click');
                }
            }
        });
        var ssnailActivateMenuItemAndChildren = function(currentMenuItem) {
            $(".ssnail-menu-wrapper.level-0 .menu-item.active").removeClass("active");
            currentMenuItem.addClass('active');
            var currentMenuItemOffsetTop = currentMenuItem.offset().top - currentMenuItem.parent().offset().top;
            var itemsToActivate = $(".ssnail-menu-wrapper.level-1 .menu-item[data-ssnail-menu-item-parent-id=" + currentMenuItem.data('ssnail-menu-item-id') + "]").show().addClass('active');
            $(".ssnail-menu-wrapper.level-1 .menu-item:not([data-ssnail-menu-item-parent-id=" + currentMenuItem.data('ssnail-menu-item-id') + "])").hide().removeClass('active');
            var level1Menu = $(".ssnail-menu-wrapper.level-1");
            if (itemsToActivate.length > 0) {
                level1Menu.addClass('active');
                if (level1Menu.hasClass('ssnail-align-with-parent')) {
                    level1Menu.css('padding-top', currentMenuItemOffsetTop + 'px');
                }
            } else {
                level1Menu.removeClass('active');
                if (level1Menu.hasClass('ssnail-align-with-parent')) {
                    level1Menu.css('padding-top', currentMenuItemOffsetTop + 'px');
                }
            }
        };
        var currentSubmenuItem = $(".ssnail-menu-wrapper.level-1 .menu-item.ssnail-current-page").first();
        if (currentSubmenuItem.length === 1) {
            var parentID = currentSubmenuItem.data("ssnail-menu-item-parent-id");
            if (parentID !== undefined) {
                var currentMenuItem = $(".ssnail-menu-wrapper.level-0 .menu-item[data-ssnail-menu-item-id=" + parentID + "]").first();
                ssnailActivateMenuItemAndChildren(currentMenuItem);
            }
        }
        ssnailPage.on("click", ".ssnail-menu-wrapper.level-0 .menu-item a.prevent-click", function(event){
            event.preventDefault();
            event.stopPropagation();
            var currentMenuItem = $(this).closest('.menu-item');
            if (currentMenuItem.hasClass('active')) {
                currentMenuItem.removeClass('active');
                var itemsToDeactivate = $(".ssnail-menu-wrapper.level-1 .menu-item[data-ssnail-menu-item-parent-id=" + currentMenuItem.data('ssnail-menu-item-id') + "]").hide().removeClass('active');
                $(".ssnail-menu-wrapper.level-1").removeClass('active');
            } else {
                ssnailActivateMenuItemAndChildren(currentMenuItem);
            }
        });

        //SCROLL TO TOP
        var scrollToTopTimer = null;
        $(".ssnail-floating-buttons .ssnail-scroll-to-top").addClass('ssnail-hidden');
        ssnailPage.on("click", ".ssnail-floating-buttons .ssnail-scroll-to-top", (event) => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
        $(window).on("scroll", (event) => {
            if (scrollToTopTimer !== null) {
                clearTimeout(scrollToTopTimer);
            }
            scrollToTopTimer = setTimeout(function(){

                if (window.scrollY > 100) {
                    $(".ssnail-floating-buttons .ssnail-scroll-to-top").removeClass('ssnail-hidden');
                } else {
                    $(".ssnail-floating-buttons .ssnail-scroll-to-top").addClass('ssnail-hidden');
                }
            }, 100);
        }).scroll();
    });
} )( jQuery );